import React, { ComponentProps } from "react";

interface Props extends ComponentProps<"div"> {
  children: React.ReactNode;
}

export function SubItem({ children, ...rest }: Props) {
  return <div {...rest}>{children}</div>;
}
